import React, { useState, useEffect } from "react";
import axios from "axios";
import { InValidURL } from "../../Components/InValidURL";
import { API_END_POINT } from "../../config";
import Questionnaire from "../Questionnaire/Questionnaire";
import { Container, Row, Col } from "react-bootstrap";
import LanguageQuestion from "../../Components/LanguageQuestion";

export default function HomeComponent({
  word,
  Latitude,
  Longitude,
  wholeWord,
}) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [errLoading, setErrLoading] = useState(false);
  const [translations, setTranslations] = useState(null);
  const InvalidURLMsg =
    "There is no data with the mentioned URL. Please provide a valid one.";

  useEffect(() => {
    if (word !== null && word !== "") {
      setLoading(true);

      axios
        .get(
          `${API_END_POINT.BASE_URL}/api/survey/GetSurveyDefinitionByCode/${word}`
        )
        .then((response) => {
          let surveyData = response.data.data;

          setData(surveyData);
          // setData(surveyLoad);
          if (
            surveyData?.surveystatus == 2 &&
            surveyData?.translations?.languages?.length > 1
          ) {
            fetchTranslations(word);
          } else {
            setLoading(false);
          }
        })
        .catch((ex) => {
          setErrLoading(true);
        });
    }
  }, [word]);
  const fetchTranslations = async (surveyCode) => {
    try {
      const response = await axios.get(
        `${API_END_POINT.BASE_URL}/api/Survey/GetSurveyTranslationByCode/${surveyCode}`
      );
      setTranslations(response?.data?.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching translations:", error);
      setLoading(false);
    }
  };

  return (
    <>
      {!loading && Object.keys(data).length > 0 ? (
        <>
          {data?.surveystatus == 2 ? (
            // Active Survey
            data?.translations?.languages?.length === 1 ||
            !data?.translations?.languages ? (
              <Questionnaire
                pages={data}
                Latitude={Latitude}
                Longitude={Longitude}
                wholeWord={wholeWord}
                hasTranslations={false}
              />
            ) : (
              <LanguageQuestion
                pages={data}
                Latitude={Latitude}
                Longitude={Longitude}
                wholeWord={wholeWord}
                translations={translations}
              />
            )
          ) : data?.surveystatus == 3 ? (
            // Survey Completed

            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                minHeight: "100vh",
                background: "#f9fafb",
                padding: "16px",
              }}
            >
              <div
                className="w-100"
                style={{
                  maxWidth: "50rem",
                  background: "white",
                  borderRadius: "0.5rem",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  padding: "1.5rem",
                  textAlign: "center",
                }}
              >
                <div className="d-flex align-items-center justify-content-center mb-3">
                  <img
                    src="/info.png"
                    alt="Info Icon"
                    style={{
                      width: "48px",
                      height: "48px",
                      marginRight: "1rem",
                    }}
                  />
                  <h1 className="fw-semibold fs-3 fs-sm-5">
                    Survey Access Period Has Concluded
                  </h1>
                </div>
                <p style={{ fontWeight: 400 }}>
                  Thank you for your interest in participating in this survey.
                  The response period has officially ended, and the survey is
                  now closed. We will share future survey opportunities as they
                  become available, and we look forward to your continued
                  engagement.
                </p>
              </div>
            </div>
          ) : data?.surveystatus == 1 ? (
            //  Survey Incomplete
            <div
              style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f9fafb",
                padding: "16px",
              }}
            >
              <div
                style={{
                  maxWidth: "50rem",
                  width: "100%",
                  background: "white",
                  borderRadius: "0.5rem",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  padding: "1.5rem",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "1rem",
                  }}
                >
                  <img
                    src="/info.png"
                    alt="Info Icon"
                    style={{
                      width: "48px",
                      height: "48px",
                      marginRight: "1rem",
                    }}
                  />
                  <h1 className="fw-semibold fs-3 fs-sm-5">
                    Survey Coming Soon!
                  </h1>
                </div>
                <p style={{ fontWeight: 400 }}>
                  Thank you for your interest in participating. This survey is
                  not yet open for responses. Please revisit the link on the
                  scheduled launch date. We appreciate your engagement and look
                  forward to your valuable input.
                </p>
              </div>
            </div>
          ) : (
            <InValidURL msg={InvalidURLMsg} errLoading={errLoading} />
          )}
        </>
      ) : (
        <InValidURL msg={InvalidURLMsg} errLoading={errLoading} />
      )}
    </>
  );
}

// dummy survey code
// const surveyLoad = {
//   "header": {
//     "title": "b",
//     "description": "",
//     "logoPosition": "right",
//     "titlePosition": "center",
//     "logo": "",
//     "surveyheadingForeground": {
//       "margin": "auto",
//       "color": "#ffffff",
//       "font-size": "27px"
//     },
//     "surveyheadingBackground": {
//       "background-color": "#030202",
//       "padding": "10px"
//     },
//     "headerErrorStatus": false
//   },
//   "footer": {
//     "previousbuttonlabel": "<<",
//     "previousbuttonstyle": {
//       "background-color": "#0000FF"
//     },
//     "nextbuttonlabel": ">>",
//     "nextbuttonstyle": {
//       "background-color": "#1b7015"
//     },
//     "progressbar": true,
//     "progressbarstyle": {
//       "background-color": "#FFFFFF"
//     },
//     "footerBackgroundcolor": "#000000",
//     "footerErrorStatus": false
//   },
//   "pages": [
//     {
//       "elements": [
//         {
//           "id": 1,
//           "tempId": "Q1-1",
//           "type": "numeric",
//           "typeId": 5,
//           "questionText": "Numeric",
//           "questionDescription": "",
//           "questionSequence": 1,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 5,
//             "name": "",
//             "label": "Numeric",
//             "options": "",
//             "questionType": "numeric",
//             "icon": "fa fa-calculator fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 1
//             },
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 2
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "",
//           "visibleIf": "",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         },
//         {
//           "id": 2,
//           "tempId": "Q1-2",
//           "type": "radiogroup",
//           "typeId": 1,
//           "questionText": "Single CHoice Test Question",
//           "questionDescription": "",
//           "questionSequence": 2,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 1,
//             "name": "",
//             "label": "Single Choice",
//             "options": "",
//             "questionType": "radiogroup",
//             "icon": "fa fa-dot-circle-o fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "Hyd",
//               "value": "Hyd",
//               "tempId": 3
//             },
//             {
//               "id": "",
//               "text": "Bangalore",
//               "value": "Bangalore",
//               "tempId": 4
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "({Q1-1} >= 21)",
//           "visibleIf": "({Q1-1} >= 21)",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         },
//         {
//           "id": 9,
//           "tempId": "Q1-9",
//           "type": "boolean",
//           "typeId": 13,
//           "questionText": "Boolean Question",
//           "questionDescription": "",
//           "questionSequence": 9,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 13,
//             "name": "",
//             "label": "Yes or No",
//             "options": "",
//             "questionType": "boolean",
//             "icon": "fa fa-thumbs-up fa-fw"
//           },
//           "labelTrue": "Yes",
//           "labelFalse": "No",
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": true,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "({Q1-2} = [Bangalore])",
//           "visibleIf": "({Q1-2} = [Bangalore])",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         }
//       ]
//     },
//     {
//       "elements": [
//         {
//           "id": 3,
//           "tempId": "Q2-3",
//           "type": "date",
//           "typeId": 7,
//           "questionText": "Date Question",
//           "questionDescription": "",
//           "questionSequence": 3,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 7,
//             "name": "",
//             "label": "Date",
//             "options": "",
//             "questionType": "date",
//             "icon": "fa fa-calendar fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 5
//             },
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 6
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "",
//           "visibleIf": "",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         },
//         {
//           "id": 4,
//           "tempId": "Q2-4",
//           "type": "checkbox",
//           "typeId": 2,
//           "questionText": "Multi Chouce",
//           "questionDescription": "",
//           "questionSequence": 4,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 2,
//             "name": "",
//             "label": "Multi Choice",
//             "options": "",
//             "questionType": "checkbox",
//             "icon": "fa fa-check-square-o fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "h",
//               "value": "h",
//               "tempId": 7
//             },
//             {
//               "id": "",
//               "text": "d",
//               "value": "d",
//               "tempId": 8
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "",
//           "visibleIf": "",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         },
//         {
//           "id": 8,
//           "tempId": "Q2-8",
//           "type": "openText",
//           "typeId": 4,
//           "questionText": "Open Text Question",
//           "questionDescription": "",
//           "questionSequence": 8,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 4,
//             "name": "",
//             "label": "Open Text",
//             "options": "",
//             "questionType": "openText",
//             "icon": "fa fa-square-o fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 1
//             },
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 2
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "",
//           "visibleIf": "",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         }
//       ]
//     },
//     {
//       "elements": [
//         {
//           "id": 5,
//           "tempId": "Q3-5",
//           "type": "rating",
//           "typeId": 9,
//           "questionText": "Smiley Question",
//           "questionDescription": "",
//           "questionSequence": 5,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 9,
//             "name": "",
//             "label": "Emoji",
//             "options": "",
//             "questionType": "rating",
//             "icon": "fa fa-smile-o fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 1
//             },
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 2
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "",
//           "visibleIf": "",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         },
//         {
//           "id": 6,
//           "tempId": "Q3-6",
//           "type": "radiogroup",
//           "typeId": 1,
//           "questionText": "Hey Check ",
//           "questionDescription": "",
//           "questionSequence": 6,
//           "rateMax": 5,
//           "minValue": 18,
//           "maxValue": 99,
//           "selectedType": {
//             "id": 1,
//             "name": "",
//             "label": "Single Choice",
//             "options": "",
//             "questionType": "radiogroup",
//             "icon": "fa fa-dot-circle-o fa-fw"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "Ok",
//               "value": "Ok",
//               "tempId": 3
//             },
//             {
//               "id": "",
//               "text": "Sure",
//               "value": "Sure",
//               "tempId": 4
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "({Q1-9} = Yes)",
//           "visibleIf": "({Q1-9} = Yes)",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         },
//         {
//           "id": 7,
//           "tempId": "Q3-7",
//           "type": "sliderScale",
//           "typeId": 14,
//           "questionText": "This is a slider Question ",
//           "questionDescription": "",
//           "questionSequence": 7,
//           "rateMax": 5,
//           "minValue": 0,
//           "maxValue": 100,
//           "selectedType": {
//             "id": 14,
//             "name": "",
//             "label": "Slider Scale",
//             "options": "",
//             "questionType": "sliderScale",
//             "icon": "fa fa-sliders"
//           },
//           "choices": [
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 1
//             },
//             {
//               "id": "",
//               "text": "",
//               "value": "",
//               "tempId": 2
//             }
//           ],
//           "dateFormat": "dd/MM/yyyy",
//           "isMandatory": false,
//           "optionWithImage": false,
//           "others": false,
//           "yesOrNo": false,
//           "choicesOrder": "normal",
//           "codedOption": false,
//           "requiredErrorText": "Answer cannot be empty",
//           "DLFormulaText": "({Q1-1} = 21 and  {Q1-2} = [Bangalore,Hyd] or  {Q2-4} = [d])",
//           "visibleIf": "({Q1-1} = 21 and  {Q1-2} = [Bangalore,Hyd]) or  ({Q2-4} = [d])",
//           "placeHolderText": "Type Here..",
//           "status": "ADDED",
//           "errorStatus": false
//         }
//       ]
//     }
//   ]
// };
